import React, { useState } from "react";
import Header from "../components/orders/Header";
import OrderTableOverview from "../components/orders/OrderTableOverview";

const Orders = () => {
  const [filters, setFilters] = useState({
    uid: "",
    orderStatus: "",
    paymentStatus: "",
    referral: "",
    productId: "",
    fromDate: "",
    toDate: "",
  });

  const [searchTerm, setSearchTerm] = useState("");

  // Debug: Log when filters change
  React.useEffect(() => {
    console.log("Orders page - filters updated:", filters);
  }, [filters]);

  React.useEffect(() => {
    console.log("Orders page - searchTerm updated:", searchTerm);
  }, [searchTerm]);

  return (
    <div>
      <Header filters={filters} searchTerm={searchTerm} />
      <OrderTableOverview
        filters={filters}
        setFilters={setFilters}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};

export default Orders;